import { Component } from '@angular/core';
import { versionInfo } from './version.config';

@Component({
  selector: 'app-version',
  templateUrl: './version.component.html',
  standalone: false,
})
export class VersionComponent {
  versionInfo = versionInfo;

  get versionLine(): string {
    const v = this.versionInfo;
    const tagPart = v.gitTag ? `(${v.gitTag})` : '';
    return `Version: ${v.commitId}${tagPart}(${v.branch}) | ${v.commitDateTime} | ${v.commitMessage} | ${v.buildTime}`;
  }
}
